import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import PreventiveCareMainTable from "@/components/preventiveCare/preventiveCareMainTable";

const PreventiveCareList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_preventive_care">
      <PreventiveCareMainTable />
    </RestrictedPage>
  );
};

export default PreventiveCareList;
